import { useEffect, useState } from "react";
import { useSearchParams } from 'react-router-dom';
import { TabBar } from "../../../components/TabBar";
import { TabItem } from "../../../components/TabItem";
import { Hobby } from "./Hobby";
import { Skill } from "./Skill";
import { Subject } from "./Subject";

export function Categories() {
  const [activeTab, setActiveTab] = useState("subjects");
  const [searchParams, setSearchParams] = useSearchParams();

  const onTabChange = (newValue: string) => {
    setSearchParams({ type: newValue });
  }


  useEffect(() => {
    let activeType = searchParams.get("type");
    if (activeType) {
      setActiveTab(activeType);
    } else {
      setActiveTab("subjects")
    }
  }, [searchParams]);


  return (
    <div className="w-full grow flex flex-col">
      <h1 className="text-xl font-semibold my-5">Category List</h1>

      <TabBar
        value={activeTab}
        onChange={onTabChange}
        textColor="text-black"
        indicatorColor="text-primary"
      >
        <TabItem value={"subjects"} label="Subjects" />
        <TabItem value={"hobbies"} label="Hobbies" />
        <TabItem value={"skills"} label="Skills" />
      </TabBar>
      <div className="w-full">

        {activeTab === "subjects" &&
          <Subject />
        }

        {activeTab === "hobbies" &&
          <Hobby />
        }

        {activeTab === "skills" &&
          <Skill />
        }
      </div>

    </div >
  )
}


